import { Grid, Typography } from "@mui/material";
import React from "react";
import "../assets/css/headerStepPractice.css";

const HeaderStepPractice = ({ currentStep, steps }) => {
  return (
    <Grid
      container
      className="bg-azure"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px 0px",
        height: "80px",
      }}
    >
      <Grid container item xs={12} md={10} style={{ display: "flex" }}>
        {steps.map((label, index) => {
          const stepNumber = index + 1;
          const isActiveStep = currentStep === stepNumber;
          const circleClass = isActiveStep ? "circle" : "circle-empty";

          return (
            <Grid
              key={stepNumber}
              item
              xs={3}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: "1px",
              }}
            >
              <Typography className="color-blue-dark text-circle">
                {label}
              </Typography>
              <div
                className={circleClass}
                aria-label={`Step ${stepNumber}`}
                role="status"
              >
                {stepNumber}
              </div>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default HeaderStepPractice;
